import { IconButton, Tooltip } from '@mui/material';
import { Edit, Visibility as VisibilityIcon, Delete } from '@mui/icons-material';
import { Fragment, memo, ReactElement, useCallback } from 'react';
import { ActiveTableActions, ItemCtaVisibility } from './types';

interface DotMenuProps {
  onVisibilityPress: () => void;
  onEditPress: () => void;
  onTrashPress: () => void;
  hidden: ItemCtaVisibility;
  active?: ActiveTableActions;
}

const ListItemCtaMenuComponent = ({
  onVisibilityPress,
  onEditPress,
  onTrashPress,
  hidden = {
    edit: false,
    read: false,
    delete: false,
  },
  active = {
    read: true,
    edit: true,
    delete: true,
  },
}: DotMenuProps): ReactElement => {
  const handleEvent = useCallback((event) => {
    event.preventDefault();
    event.stopPropagation();
  }, []);

  return (
    <Fragment>
      {!hidden.read ? (
        <Tooltip
          arrow
          title={
            active.read
              ? 'Visualizza'
              : "Non si ha l'autorizzazione per accedere a questa funzionalità"
          }
        >
          <span>
            <IconButton
              onClick={(event) => {
                handleEvent(event);
                onVisibilityPress();
              }}
              aria-label="Visualizza elemento"
              aria-haspopup="true"
              disabled={!active.read}
              style={{
                padding: '4px',
              }}
            >
              <VisibilityIcon />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
      {!hidden.edit ? (
        <Tooltip
          arrow
          title={
            active.edit
              ? 'Modifica'
              : "Non si ha l'autorizzazione per accedere a questa funzionalità"
          }
        >
          <span>
            <IconButton
              aria-label="Modifica elemento"
              aria-haspopup="true"
              onClick={(event) => {
                handleEvent(event);
                onEditPress();
              }}
              disabled={!active.edit}
              style={{
                padding: '4px',
              }}
            >
              <Edit />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
      {!hidden.delete ? (
        <Tooltip
          arrow
          title={
            active.delete
              ? 'Elimina'
              : "Non si ha l'autorizzazione per accedere a questa funzionalità"
          }
        >
          <span>
            <IconButton
              aria-label="Elimina elemento"
              aria-haspopup="true"
              color="cdmBrand"
              onClick={(event) => {
                handleEvent(event);
                onTrashPress();
              }}
              disabled={!active.delete}
              style={{
                padding: '4px',
              }}
            >
              <Delete />
            </IconButton>
          </span>
        </Tooltip>
      ) : null}
    </Fragment>
  );
};

ListItemCtaMenuComponent.displayName = 'List Cta Dot Menu';

const ListItemCtaMenu = memo(ListItemCtaMenuComponent);

export default ListItemCtaMenu as typeof ListItemCtaMenuComponent;
